/* eslint-disable no-underscore-dangle */
import { SgAdobeMVTService } from 'saga-modules';

const qnbFlowURL = '/journey';
const trackCommand = 'runSidMotorTests';
const ENTRY_POINTS = ['/new-quote', '/sg-spm-quoteentry', '/sg-home-quoteentry', '/mySagaEntry', '/renewalentry', '/aggregatorEntry'];
let satelliteAvailable = false;
const siteContent = document.getElementById('root');

const showContent = () => {
    if (siteContent.style.opacity === '0') {
        siteContent.style.opacity = 1;
    }
};

/*
 * @param url Location URL
 * @returns State URL (name only)
 */
const getStateURL = () => {
    const path = window.location.pathname;
    const { scid } = window.location.search;
    if (scid && scid.includes('agg')) {
        return 'agg';
    }
    if (path.includes(qnbFlowURL)) {
        return path.split(qnbFlowURL)[1];
    }
    return path;
};

const hideContent = () => {
    const mvtPages = SgAdobeMVTService.getMvtPages();
    if (!mvtPages || mvtPages.length === 0) {
        showContent();
        return;
    }
    // Take the page parameter if exists or the url otherwise
    const page = window.location.search.p !== undefined ? `/${window.location.search}` : getStateURL();
    if (mvtPages.indexOf(page) === -1) {
        showContent();
        return;
    }
    const { body } = document;
    // const translatePromise = LocaleService.whenTranslateReady();
    // translatePromise.then(() => {
    siteContent.style.opacity = 0;
    // arbitrary data object to be passed to Target
    const data = {
        sidPageHash: window.location.pathname,
        sidPageElement: body
    };
    if (satelliteAvailable) {
        // set arbitrary data in Target
        window._satellite.setVar(data);
        SgAdobeMVTService.setRefreshFlag(false);
        window._satellite.track(trackCommand);
    }
    const testDirectRule = window._satellite._container.rules.find((rule) => rule.events.find((event) => (event.settings.identifier
        ? event.settings.identifier.includes(trackCommand)
        : undefined
    )));
    const mboxCookie = document.cookie.match('mbox');
    if (
        testDirectRule === undefined
        || !satelliteAvailable
        || window.adobe === undefined
        || window.adobe.target === undefined
        || mboxCookie === undefined
    ) {
        showContent();
    }
    setTimeout(() => { // fallback timeout
        showContent();
    }, 1000);
};

const locationChanged = () => {
    if (!satelliteAvailable) {
        return;
    }
    // Entry points don't have the content - hides the logo
    if (ENTRY_POINTS.indexOf(getStateURL()) !== -1) {
        siteContent.style.opacity = 0;
    } else {
        hideContent();
    }
};

const initTargetCapability = () => {
    satelliteAvailable = window._satellite && window._satellite.setVar && window._satellite.track;

    window.sgRunAdobeTargetTest = function (test) {
        SgAdobeMVTService.runTest(test);
    };

    if (window.adobe && window.adobe.target) {
        document.addEventListener(window.adobe.target.event.REQUEST_SUCCEEDED, (event) => {
            if (!event.detail.responseTokens) {
                showContent();
            }
        });
        document.addEventListener(window.adobe.target.event.REQUEST_FAILED, () => {
            showContent();
        });
        document.addEventListener(window.adobe.target.event.CONTENT_RENDERING_NO_OFFERS, () => {
            showContent();
        });
        document.addEventListener(window.adobe.target.event.CONTENT_RENDERING_SUCCEEDED, () => {
            showContent();
        });
        document.addEventListener(window.adobe.target.event.CONTENT_RENDERING_FAILED, () => {
            showContent();
        });
    }
};

export default {
    locationChanged,
    initTargetCapability
};
